import {Toast} from 'vant';

export default {
  install: function (Vue) {
    Vue.filter('filstatus', value => {
      let _val = ''
      switch (value) {
        case false:
          _val = 0
          break
        case true:
          _val = 1
          break
        default:
          _val = 0
      }
      return _val
    })

    // 时间转换器
    Vue.filter('reformat', function (value, former, later) {
      return value.split(former).join(later);
    });

    Vue.prototype.getStringColor = function (score) {
      if (score > 84) {
        return 'greencr'
      } else if (score <= 84 && score >= 60) {
        return 'bluecr'
      } else if (score >= 0 && score < 60) {
        return 'redcr'
      } else {
        return 'graycr'
      }
    }

    Vue.prototype.formathtml = function (options) {
      var str = options.replace(/\\n/g, "</br>");
      return str
    }
    Vue.prototype.getOptionIndex = function () {

      return ["A","B","C","D","E","F","G","H","I","J","K",]
    }
    Date.prototype.format = function (fmt) {
      let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
        }
      }
      return fmt
    }

    String.prototype.timeFormat = function (timedata){
      var that = this
      timedata=that.replace(/-/g,"/").replace("T"," ");
      var date = new Date(timedata.substr(0, 19));
      var Year = date.getFullYear();
      var Month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var Hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var Minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var Seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      var over_time = Year + "/" + Month + "/" + d + " " + Hours + ":" + Minutes + ":" + Seconds
      //***至此以上是将时间2020-03-18T01:57:23.000+0000转为正常时间格式，以下为将时间进行增加8小时解决时区差异的操作***
      var time = new Date(Date.parse(over_time));
      var Y = time.getFullYear() + '-';
      var M =addZero(time.getMonth() + 1) + '-';
      var D =addZero(time.getDate()) + ' ';
      var h = addZero(time.getHours()) + ':';
      var m =addZero(time.getMinutes()) + ':';
      var s =addZero(time.getSeconds());
      return (Y + M + D + " " + h + m + s)
    }
//不足10 补0操作
    var addZero=function (num) {
      return num < 10 ? '0' + num : num;
    }
    Date.prototype.getBJDate = function () {
      //获得当前运行环境时间
      var d = new Date(), currentDate = new Date(), tmpHours = currentDate.getHours();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      //少于0的是西区 西区应该用时区绝对值加京八区 重新设置时间（西区时间比东区时间早 所以加时区间隔）
      if (time_zone < 0) {
        time_zone = Math.abs(time_zone) + 8;
        currentDate.setHours(tmpHours + time_zone);
      } else {
        //大于0的是东区  东区时间直接跟京八区相减
        time_zone -= 8;
        currentDate.setHours(tmpHours - time_zone);
      }
      return currentDate;
    }
    Date.prototype.getWeekformat = function () {
      var lang = JSON.parse(localStorage.getItem("user")).language_type;
      if (lang == "zh") {
        return "周" + "日一二三四五六".charAt(this.getDay());
      } else {
        var day = this.getDay()
        if (day == 0) {
          return "Sunday"
        } else if (day == 1) {
          return "Monday"
        } else if (day == 2) {
          return "Tuesday"
        } else if (day == 3) {
          return "Wednesday"
        } else if (day == 4) {
          return "Thursday"
        } else if (day == 5) {
          return "Friday"
        } else if (day == 6) {
          return "Saturday"
        }
      }
    }

    String.prototype.tounicode=function(){
      var str=this
      var res = [];
      for ( var i=0; i<str.length; i++ ) {
        res[i] = ( "00" + str.charCodeAt(i).toString(16) ).slice(-4);
      }
      return "\\u" + res.join("\\u");
    }

    String.prototype.format = function () {
      if (arguments.length == 0) return this;
      var param = arguments[0];
      var s = this;
      if (typeof (param) == 'object') {
        for (var key in param)
          s = s.replace(new RegExp("\\{" + key + "\\}", "g"), param[key]);
        return s;
      } else {
        for (var i = 0; i < arguments.length; i++)
          s = s.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
        return s;
      }
    }

    Vue.prototype.randomSort = function (a) {
      var arr = a,
        random = [],
        len = arr.length;
      for (var i = 0; i < len; i++) {
        var index = Math.floor(Math.random() * (len - i));
        random.push(a[index]);
        arr.splice(index, 1);
      }
      return random;
    }
    Vue.prototype.hasClass = function (elements, cName) {
      return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
    }
    Vue.prototype.addClass = function (elements, cName) {
      if (!this.hasClass(elements, cName)) {
        elements.className += " " + cName;
      }
      ;
    }
    Vue.prototype.removeClass = function (elements, cName) {
      if (this.hasClass(elements, cName)) {
        elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
      }
    }
    Vue.prototype.replaceParams = function (opt, params) {
      var options = JSON.parse(JSON.stringify(opt))
      Object.keys(params).forEach((key, i, v) => {
        let keys = key;
        options.url = options.url.replace("{" + key + "}", params[v])
      })
      return options;
    }
    Vue.prototype.secondToDate = function (result) {
      var h = Math.floor(result / 3600);
      var m = Math.floor((result / 60 % 60));
      var s = Math.floor((result % 60));
      var str = "";
      if (h > 0) {
        str += h + "时"
      }
      if (m > 0) {
        str += m + "分"
      }
      if (s > 0) {
        str += s + "秒"
      }
      return str;
    }
    Vue.prototype.parseJson = function (arr) {
      var map = {},
        dest = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.act_tab_id]) {
          dest.push({
            id: ai.act_tab_id,
            name: ai.act_tab_name,
            act: [ai]
          });
          map[ai.act_tab_id] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.id == ai.act_tab_id) {
              dj.act.push(ai);
              break;
            }
          }
        }
      }
      return dest;
    }
    String.prototype.ResetBlank = function () {
      var regEx = /\s+/g;
      return this.replace(regEx, ' ');
    };
    Vue.prototype.detectOS = () => {
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
      if (isWin) return "Win"
      var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
      if (isMac) return "Mac";

    }

  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js